import { render, staticRenderFns } from "./MediaTagHandling.vue?vue&type=template&id=913a35b4&scoped=true&"
import script from "./MediaTagHandling.vue?vue&type=script&lang=js&"
export * from "./MediaTagHandling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913a35b4",
  null
  
)

export default component.exports